(() => {
  const openDefaultFooterAccordions = () => {
    document
      .querySelectorAll('.footer .js-accordion-item.is-default-open')
      .forEach(item => {
        const control = item.querySelector('.js-accordion-control');
        const content = item.querySelector('.js-accordion-content');

        if (!control || !content) return;

        control.setAttribute('aria-expanded', 'true');
        content.style.height = content.scrollHeight + 'px';
        content.classList.add('is-open');
      });
  };

  openDefaultFooterAccordions();

  const syncCollectionBreadcrumb = () => {
    const storageKey = 'isoora:lastCollectionBreadcrumb';
    const breadcrumb = document.querySelector('.breadcrumb[data-breadcrumb-page-type]');

    if (!breadcrumb) return;

    const normalizePath = (value) => {
      try {
        return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/';
      } catch (_) {
        return '';
      }
    };

    if (breadcrumb.dataset.breadcrumbPageType === 'collection') {
      const { breadcrumbCollectionHandle, breadcrumbCollectionTitle, breadcrumbCollectionUrl } = breadcrumb.dataset;

      if (!breadcrumbCollectionHandle || !breadcrumbCollectionTitle || !breadcrumbCollectionUrl) return;

      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          handle: breadcrumbCollectionHandle,
          title: breadcrumbCollectionTitle,
          url: breadcrumbCollectionUrl
        }));
      } catch (_) {}

      return;
    }

    if (breadcrumb.dataset.breadcrumbPageType !== 'product') return;

    let collection;

    try {
      collection = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    } catch (_) {
      collection = null;
    }

    if (!collection || !collection.title || !collection.url || !document.referrer) return;

    let referrer;

    try {
      referrer = new URL(document.referrer);
    } catch (_) {
      return;
    }

    if (referrer.origin !== window.location.origin) return;
    if (normalizePath(referrer.pathname) !== normalizePath(collection.url)) return;

    const container = breadcrumb.querySelector('.breadcrumb__container');
    const currentItem = container?.querySelector('.breadcrumb__item:last-child');
    const productSeparator = currentItem?.previousElementSibling?.classList.contains('breadcrumb__separator')
      ? currentItem.previousElementSibling
      : null;

    if (!container || !currentItem || container.querySelectorAll('.breadcrumb__item').length > 1 || container.querySelector(`[data-breadcrumb-injected-collection="${collection.handle}"]`)) {
      return;
    }

    const separator = document.createElement('span');
    separator.setAttribute('aria-hidden', 'true');
    separator.className = 'breadcrumb__separator';
    separator.textContent = '·';

    const link = document.createElement('a');
    link.className = 'breadcrumb__item breadcrumb__link';
    link.href = collection.url;
    link.textContent = collection.title;
    link.dataset.breadcrumbInjectedCollection = collection.handle || 'true';

    (productSeparator || currentItem).before(separator, link);
  };

  syncCollectionBreadcrumb();

  // Optional: bei Resize neu berechnen
  window.addEventListener('resize', () => {
    document
      .querySelectorAll('.footer .js-accordion-item.is-default-open .js-accordion-content')
      .forEach(content => {
        content.style.height = content.scrollHeight + 'px';
      });
  });

  // Product sharebutton instagram
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-instagram-share');
    if (!btn) return;

    e.preventDefault();

    const url = btn.dataset.shareUrl;
    if (!url) return;

    // Copy (Fallback, zuverlässig)
    let copied = false;
    try {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      copied = document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (_) {}

    // Tooltip zeigen (falls vorhanden)
    const tip = btn.querySelector('.js-instagram-tooltip');
    if (tip) {
      tip.hidden = false;
      setTimeout(() => { tip.hidden = true; }, 1800);
    } else if (copied) {
      // minimal fallback feedback
      console.log('Link kopiert:', url);
    }

    // Instagram öffnen
    window.open(btn.href, '_blank', 'noopener');
  }, true);
})();
